<template>
  <Slidein :extra-classes="['slidein-menu']" type="menu">
    <template v-slot:content>
      <div class="slidein__header">
        <a
          class="slidein__close"
          @click="
            $store.commit('showSlidein', { slidein: 'menu', show: false })
          "
          :title="str('global.back')"
        >
          <Arrow />
        </a>
        <router-link
          to="/"
          class="slidein__logo"
          @click.native="
            $store.commit('showSlidein', { slidein: 'menu', show: false })
          "
        >
          <img
            class="slidein__logo-img"
            :src="$store.getters.supplierData.logoUrl"
            :alt="$store.getters.supplierData.name"
          />
        </router-link>
      </div>

      <div class="slidein__content">
        <h2 v-if="availableCubes.length > 1" class="slidein__headline">
          Meine Cubes
        </h2>
        <ul v-if="availableCubes.length > 1" class="slidein__list">
          <li
            v-for="cube in availableCubes"
            :key="cube.cubeName"
            class="slidein__list-item"
          >
            <a :class="cubeLinkClasses(cube)" @click="cube.callback(cube)">
              {{ cube.nickName }}
              <Check v-if="cube.isSelected" />
            </a>
          </li>
        </ul>
        <div v-else class="slidein__cube">
          <img
            class="slidein__cube-icon"
            :src="$store.getters.cubeIconUrl(false, 'svg')"
          />
          <span class="slidein__cube-nickname">{{
            $store.getters.nickName
          }}</span>
        </div>

        <ul class="slidein__list">
          <li
            v-for="item in menuItems"
            :key="item.title"
            class="slidein__list-item"
          >
            <router-link
              :to="item.link"
              class="slidein__link"
              @click.native="menuLinkClicked(item, $event)"
            >
              {{ str(item.text) }}
              <span
                class="slidein__link-notifications"
                v-if="
                  $store.getters.numNotificationsForTypeGroup(
                    item.notificationTypeGroup
                  ) > 0
                "
              >
                {{
                  $store.getters.numNotificationsForTypeGroup(
                    item.notificationTypeGroup
                  )
                }}
              </span>
              <component v-else-if="item.icon" :is="item.icon" />
            </router-link>
          </li>
        </ul>
      </div>
    </template>
  </Slidein>
</template>

<script>
  import Slidein from '@/components/slidein/Slidein'
  import Arrow from '@/components/icons/Arrow'
  import Check from '@/components/icons/Check'
  import Edit from '@/components/icons/Edit'

  export default {
    name: 'slidein-menu',
    components: {
      Edit,
      Slidein,
      Arrow,
      Check,
    },
    data() {
      return {
        menuItems: [
          {
            link: '/notifications',
            text: 'notifications.menuTitle',
            icon: 'Arrow',
            notificationTypeGroup: 'any',
          },
          {
            link: '/my-data',
            text: 'myData.menuTitle',
            icon: 'Arrow',
          },
          {
            link: '/settings',
            text: 'settings.menuTitle',
            icon: 'Arrow',
          },
          {
            link: '/invoices',
            text: 'invoices.menuTitle',
            icon: 'Arrow',
            notificationTypeGroup: 'invoices',
          },
          {
            link: '/downloads',
            text: 'downloads.menuTitle',
            icon: 'Arrow',
          },
          {
            link: '/experts',
            text: 'experts.menuTitle',
            icon: 'Arrow',
          },
          {
            link: '/about-app',
            text: 'aboutApp.menuTitle',
            icon: 'Arrow',
          },
          {
            link: '/login',
            text: 'global.logout',
            callback: () => {
              this.$store.dispatch('logoutUser')
            },
          },
        ],
      }
    },
    computed: {
      availableCubes() {
        const currentCubeName = this.$store.getters.cubeName
        return this.$store.getters.availableCubes.map((cube) => {
          cube.isSelected = cube.cubeName === currentCubeName
          cube.callback = (cube) => {
            this.$store.dispatch('selectCube', cube.cubeName)
          }
          return cube
        })
      },
    },
    methods: {
      cubeLinkClasses(cube) {
        let classes = ['slidein__link']
        if (cube.isSelected) {
          classes.push('slidein__link--selected-cube')
        }
        return classes.join(' ')
      },
      menuLinkClicked(menuItem, ev) {
        this.$store.commit('showSlidein', { slidein: 'menu', show: false })
        if (typeof menuItem.callback === 'function') {
          menuItem.callback(menuItem, ev)
        }
      },
    },
  }
</script>

<style lang="scss">
  .slidein__cube-edit {
    color: $grey-dark;

    .icon {
      width: 1em;
    }
  }
</style>
